import { z } from 'zod/v4';

export type ManufacturingKvKeyValueDTO = z.infer<typeof ManufacturingKvKeyValueRuntype>;
export const ManufacturingKvKeyValueRuntype = z.object({
    key: z.string(),
    value: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type ManufacturingKvKeyValueInputDTO = z.infer<typeof ManufacturingKvKeyValueInputRuntype>;
export const ManufacturingKvKeyValueInputRuntype = z.object({
    key: z.string(),
    value: z.string(),
});

export type ManufacturingKvKeyValueUpdateDTO = z.infer<typeof ManufacturingKvKeyValueUpdateRuntype>;
export const ManufacturingKvKeyValueUpdateRuntype = z.object({
    value: z.string(),
});
